import { useEffect, useState } from "react";
import axios from "axios";

import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import useFetch from "../hooks/useFetch";
import { basePath } from "../utility";

const Search = () => {
  const [searchCategory, setSearchCategory] = useState(null);
  const [searchText, setSearchText] = useState(null);
  const [categoryList, isPending, error] = useFetch(
    `${basePath.url}books/categories`
  );

  const handleSearch = () => {
    alert(searchCategory);
    alert(searchText);
  };
  return (
    <div className="search-wrapper">
      <div
        style={{
          height: 40,
          backgroundColor: "#ccc",
          boxSizing: "border-box",
          border: 0,
          borderRadius: "5px",
          borderTopRightRadius: 0,
          borderBottomRightRadius: 0,
          boxSizing: " border-box",
        }}
      >
        <select
          className="search-category-select"
          name={searchCategory}
          id="searchCategory"
          onChange={(e) => {
            setSearchCategory(e.target.value);
          }}
          style={{ scrollbarWidth: "thin", scrollbarColor: "#3d3c3c white" }}
        >
          <option
            value=""
            style={{ fontFamily: "sans-serif", fontWeight: 600 }}
          >
            All Categories
          </option>

          {categoryList &&
            categoryList.map((category, index) => {
              return (
                <option
                  key={category.entry_id}
                  style={{ fontFamily: "sans-serif", fontWeight: 600 }}
                  value={category.entry_id}
                >
                  {category.category_name}
                </option>
              );
            })}
        </select>
      </div>
      <div
        style={{
          flexGrow: 1,
          height: "40px",
          justifyContent: "center",
          alignItems: "center",
          margin: 0,
          padding: 0,
          boxSizing: " border-box",
        }}
      >
        <input
          className="search-text-input"
          name={searchText}
          id="searchText"
          onChange={(e) => {
            setSearchText(e.target.value);
          }}
          style={{ boxSizing: "border-box" }}
          placeholder="Enter Book Author, Title or Description"
        />
      </div>
      <div
        style={{
          height: 40,
          width: 50,
          cursor: "pointer",
          backgroundColor: "#f7b802",
          boxSizing: "border-box",
          borderRadius: "5px",
          border: 0,
          borderRadius: 5,
          borderTopLeftRadius: 0,
          borderBottomLeftRadius: 0,

          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <SearchOutlinedIcon
          className="search-button-icon"
          onClick={handleSearch}
          style={{ fontSize: 30 }}
        />
      </div>
    </div>
  );
};

export default Search;
